/**
 * Payment Constants
 *
 * Shared constants for the payment domain, used across the mapper and the hooks
 * that consume `PaymentConceptItem`.
 */

/**
 * Etiquetas de estado que la API considera un error de envío y que habilitan el menú de
 * acciones con "Ver detalle" (ASIS-5318).
 *
 * Deben coincidir EXACTAMENTE con las etiquetas de PaymentConceptStatusConstants.cs
 * (backend/Contratos/Attendance/PaymentConcept/Common/), que es la fuente de verdad.
 *
 * "Estado desconocido" queda EXCLUIDO a propósito: por decisión de negocio (ASIS-5318) no se
 * trata como error y por tanto no muestra el menú de acciones.
 */
export const PAYMENT_CONCEPT_ERROR_STATUSES: readonly string[] = [
  'Datos errados',
  'Error REX+',
] as const;
